import { accessToken } from './auth';

export interface ApiOptions extends RequestInit {
  tenantId?: string;
}

export async function api<T>(path: string, options: ApiOptions = {}): Promise<T> {
  const token = accessToken();
  const headers = new Headers(options.headers);
  headers.set('accept', 'application/json');
  if (options.body && !headers.has('content-type')) headers.set('content-type', 'application/json');
  if (token) headers.set('authorization', `Bearer ${token}`);
  if (options.tenantId) headers.set('x-thisbot-workspace', options.tenantId);

  const response = await fetch(`/api${path}`, { ...options, headers });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { message?: string };
    throw new Error(body.message ?? 'ThisBot could not complete that request.');
  }
  return response.json() as Promise<T>;
}

